import { FC, ReactElement } from 'react'

import { ASSETS, defaultCardImage } from '../../../constants'
import { useI18n } from '../../../hooks'
import { useAppSelector } from '../../../store'
import { ProductWithVariants } from '../../../types'
import { random, getAmountWithCurrency } from '../../../utils'
import Image from '../../atoms/images/image'

import './index.css'
import './productMainCard.css'

const ProductMainCard: FC<{ product: ProductWithVariants }> = ({ product }): ReactElement => {
  const { t } = useI18n()
  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const { mediaUrls, name, asLowAs } = product
  const { locale } = settings
  const productImage = mediaUrls
    ? mediaUrls.find(({ displayIntent }) => displayIntent === 'card_image' || displayIntent === 'CardImage') || defaultCardImage
    : defaultCardImage
  return (
    <div className="product-main-card__container">
      <div className="product-card__image__container">
        <div className="product-card__image__background" style={{ backgroundImage: `url("${productImage.url}")` }}></div>
        <Image
          className="product-card__image"
          src={productImage.url || `${ASSETS}/default/products/Mobile_${random(4, 1)}.jpg`}
          alt={productImage.alt || 'On the Hub product image'}
          size={{ width: 'auto', height: 'auto' }}
          sizeType="card"
        />
      </div>
      <div className="product-main-card__name">{name}</div>

      <div className="product-main-card__price__container">
        {asLowAs.price ? (
          <>
            {asLowAs.msrp ? (
              <div
                className="product-main-card__price__oldprice product-card__general__font--light"
                role="note"
                aria-label={t('Common_oldPrice') + ': ' + getAmountWithCurrency(locale.language, asLowAs.currencyType, asLowAs.msrp)}
              >
                <div aria-hidden>{getAmountWithCurrency(locale.language, asLowAs.currencyType, asLowAs.msrp)}</div>
              </div>
            ) : null}
            <div
              className="product-main-card__price__currentprice product-card__general__font--bold"
              role="note"
              aria-label={
                t('Common_startingFromPrice') + ': ' + getAmountWithCurrency(locale.language, asLowAs.currencyType, asLowAs.price)
              }
            >
              <div aria-hidden>{getAmountWithCurrency(locale.language, asLowAs.currencyType, asLowAs.price)}</div>
            </div>
          </>
        ) : (
          <>{t('Common_free')}</>
        )}
      </div>
    </div>
  )
}

export default ProductMainCard
